(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/bottom-sheet/assets/javascripts/shared/listeners.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/bottom-sheet/assets/javascripts/shared/listeners.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => listeners
  });
  ; 

  const DIRECTION_UP = 'up';
  const DIRECTION_DOWN = 'down';
  const DIRECTION_BOTH = 'both';
  const DIRECTION_NONE = 'none';
  const STATE_EXPANDED = 'expanded';
  const STATE_HALF_EXPANDED = 'half-expanded';
  const STATE_COLLAPSED = 'collapsed';
  const BEHAVIOR_STANDARD = 'standard';
  const BEHAVIOR_MODAL = 'modal';
  const BEHAVIOR_HYBRID = 'hybrid';
  const constants = {
    DIRECTION_UP,
    DIRECTION_DOWN,
    DIRECTION_BOTH,
    DIRECTION_NONE,
    STATE_EXPANDED,
    STATE_HALF_EXPANDED,
    STATE_COLLAPSED,
    BEHAVIOR_MODAL,
    BEHAVIOR_STANDARD,
    BEHAVIOR_HYBRID
  };
  ; 

  class Listeners {
    constructor(options) {
      this.utils = options.utils;
    }

    handlePointer(e) {
      const settings = this.utils.getSettings();
      const clientY = e.type === 'touchmove' ? e.changedTouches[0].clientY : e.clientY;
      if (settings.allowSwipeResizeFromContent || settings.allowedDirections === DIRECTION_BOTH) {
        if (settings.isPressed && settings.previousY && Math.abs(settings.previousY - clientY) > 0.5) {
          const difference = Math.abs(settings.previousY - clientY);
          settings.gestureDirection = clientY < settings.previousY ? DIRECTION_UP : DIRECTION_DOWN;
          if (settings.gestureDirection === DIRECTION_UP && settings.allowedDirections === DIRECTION_BOTH || settings.gestureDirection === DIRECTION_UP && settings.allowExpand) {
            settings.allowedDirections = DIRECTION_BOTH;
            settings.currentHeight = settings.currentHeight + difference;
          } else if (settings.gestureDirection === DIRECTION_DOWN && settings.allowedDirections === DIRECTION_BOTH || settings.gestureDirection === DIRECTION_DOWN && settings.allowCollaps) {
            settings.allowedDirections = DIRECTION_BOTH;
            settings.currentHeight = settings.currentHeight - difference;
          }
          settings.currentHeight = settings.currentHeight >= settings.maxHeight + 12 ? settings.maxHeight + 12 : settings.currentHeight;
          settings.resizeEl.style.transitionDuration = "0ms";
          settings.resizeEl.style.maxHeight = "".concat(settings.currentHeight, "px");
        }
        settings.previousY = clientY;
      }
      this.utils.updateSettings(settings);
    }

    handleMouseTouchUp(e) {
      const settings = this.utils.getSettings();
      if (settings.isPressed) {
        settings.endTime = new Date().getTime();
        const y = event.type === 'touchend' ? e.changedTouches[0].screenY : e.screenY;
        settings.endY = y;
        settings.isPressed = false;
        if (y === settings.startY && settings.allowClickExpansion) {
          settings.gestureDirection = settings.gestureDirection && settings.gestureDirection === DIRECTION_UP ? DIRECTION_DOWN : DIRECTION_UP;
        }
        const speed = Math.abs(settings.endTime - settings.startTime) / Math.abs(settings.endY - settings.startY) / 2;
        if (settings.allowedDirections === DIRECTION_BOTH || settings.allowedDirections.includes(settings.gestureDirection)) {
          this.utils.setState(speed);
        }
      }
      this.utils.resetStates();
      this.utils.updateSettings(settings);
    }

    handleMouseTouchDown(e) {
      var _settings$swipeContro;
      const settings = this.utils.getSettings();
      if (settings.el.querySelector('.js-bottom-sheet-draggable').contains(e.target)) {
        e.preventDefault();
        settings.allowClickExpansion = true;
        settings.allowedDirections = DIRECTION_BOTH;
      } else if (settings.allowHeaderSwipe && settings.el.querySelector('.js-bottom-sheet-header').contains(e.target)) {
        settings.log.info('Click on header');
        settings.allowedDirections = DIRECTION_BOTH;
      } else {
        settings.allowClickExpansion = false;
        settings.allowedDirections = settings.allowExpand ? DIRECTION_UP : settings.allowCollaps ? DIRECTION_DOWN : DIRECTION_NONE;
      }
      (_settings$swipeContro = settings.swipeController) === null || _settings$swipeContro === void 0 || _settings$swipeContro.abort();
      settings.swipeController = new AbortController();
      const y = e.type === 'touchstart' ? e.changedTouches[0].screenY : e.screenY;
      settings.isPressed = true;
      settings.startY = y;
      settings.startTime = new Date().getTime();
      if (e.type === 'touchstart') {
        document.querySelector('body').style.height = '100vh';
        document.querySelector('body').style.overflowY = 'hidden';
        document.addEventListener('touchend', e => {
          this.handleMouseTouchUp(e);
        }, {
          signal: settings.touchController.signal
        });
        document.addEventListener('touchmove', e => {
          this.handlePointer(e);
        }, {
          signal: settings.swipeController.signal
        });
      } else {
        document.addEventListener('mouseup', e => {
          this.handleMouseTouchUp(e);
        }, {
          signal: settings.touchController.signal
        });
        document.addEventListener('mousemove', e => {
          this.handlePointer(e);
        }, {
          signal: settings.swipeController.signal
        });
      }
      this.utils.updateSettings(settings);
    }

    init() {
      const settings = this.utils.getSettings();
      if (!settings.isFixed) {
        settings.touchController = new AbortController();
        settings.el.addEventListener('touchstart', e => {
          this.handleMouseTouchDown(e);
        }, {
          signal: settings.touchController.signal,
          passive: false
        });
        settings.el.addEventListener('mousedown', e => {
          this.handleMouseTouchDown(e);
        }, {
          signal: settings.touchController.signal
        });

        if (!settings.isModal) {
          settings.el.querySelector('.js-bottom-sheet-collapse').addEventListener('click', () => {
            settings.gestureDirection = DIRECTION_DOWN;
            settings.ignoreTwoSteps = true;
            this.utils.updateSettings(settings);
            this.utils.setState(0);
          }, {
            signal: settings.touchController.signal
          });
        }
        const obCallback = payload => {
          const set = {
            allowExpand: false,
            allowCollaps: false,
            allowSwipeResizeFromContent: false
          };
          if (payload[0].target.className.includes('js-bottom-sheet-watch-end')) {
            set.allowExpand = payload[0].isIntersecting;
          } else {
            set.allowCollaps = payload[0].isIntersecting;
          }
          set.allowSwipeResizeFromContent = set.allowCollaps || set.allowExpand;
          this.utils.updateSettings(set);
        };
        const ob = new IntersectionObserver(obCallback);
        ob.observe(settings.endWatch);
        ob.observe(settings.startWatch);
      }
      if (settings.isModal) {
        settings.el.querySelector('.js-bottom-sheet-close').addEventListener('click', () => {
          settings.hideSheet();
        }, {
          signal: settings.touchController.signal
        });
      }
      this.utils.updateSettings(settings);
      this.utils.setState();
    }
    destroy() {
      var _settings$touchContro, _settings$swipeContro2;
      const settings = this.utils.getSettings();
      (_settings$touchContro = settings.touchController) === null || _settings$touchContro === void 0 || _settings$touchContro.abort();
      (_settings$swipeContro2 = settings.swipeController) === null || _settings$swipeContro2 === void 0 || _settings$swipeContro2.abort();
    }
  }
  const listeners = Listeners;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).BottomSheet = window.svs.ui.BottomSheet || {}).BottomSheetListeners = __webpack_exports__["default"];
})();

 })(window);